/**
 * @generated SignedSource<<c9fcd34bf8dbf08c66cd97adc6c2461a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PromotionDescriptionList_promotion$data = {
  readonly created: any;
  readonly createdBy: {
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"UserAvatarText_user">;
  };
  readonly endAt: any;
  readonly id: string;
  readonly page: {
    readonly __typename: "PromotionPage";
  } | null;
  readonly priority: number;
  readonly query: string | null;
  readonly startAt: any;
  readonly title: string;
  readonly " $fragmentSpreads": FragmentRefs<"PromotionRepeatText_promotion" | "PromotionStatusLabel_promotion">;
  readonly " $fragmentType": "PromotionDescriptionList_promotion";
};
export type PromotionDescriptionList_promotion$key = {
  readonly " $data"?: PromotionDescriptionList_promotion$data;
  readonly " $fragmentSpreads": FragmentRefs<"PromotionDescriptionList_promotion">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PromotionDescriptionList_promotion",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "priority",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PromotionPage",
      "kind": "LinkedField",
      "name": "page",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__typename",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "startAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endAt",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PromotionRepeatText_promotion"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "query",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "createdBy",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "UserAvatarText_user"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "created",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PromotionStatusLabel_promotion"
    }
  ],
  "type": "Promotion",
  "abstractKey": null
};
})();

(node as any).hash = "9e8c76013c6a01feeb87381de52eecb7";

export default node;
